import { useEffect, useState } from "react";
import { OrderFindedType } from "../../pages/SearchOrders";
import { FaPlusCircle, FaMinusCircle } from "react-icons/fa";
import "./index.css";
import { centsToFloat, floatToPrice } from "../../functions/price_functions";
import Swal from "sweetalert2";
import { MainButton } from "../MainButton";
import { ConfigType } from "../../contexts/AppConfigContext";
import api from "../../services/api";
import { usePluginspace } from "../../hooks/usePluginspace";
import { Loading } from "../Loading";
import { useProduct } from "../../hooks/useProduct";
import { ModalCancel } from "../ModalCancel";
import useAuth from "../../hooks/useAuth";

type SearchOrderItemProps = {
  order: OrderFindedType;
  fontStatus?: string;
  colorStatus?: string;
  colorActiveStatus?: string;
  config: ConfigType | null;
};

export function SearchOrderItem({
  order,
  colorStatus,
  colorActiveStatus,
  fontStatus,
  config,
}: SearchOrderItemProps) {
  const [extended, setExtended] = useState(false);
  const [loading, setLoading] = useState(false);
  const { getToken, registerAccess } = usePluginspace();
  const { organizeFractions } = useProduct();
  const [modalOpen, setModalOpen] = useState(false);
  const [omitGrade, setOmitGrade] = useState(
    !(config?.content?.pdv?.omitGrid ?? true)
  );
  const [showSku, setShowSku] = useState(
    config?.content?.showProductSku ?? true
  );

  function totalValueWithoutDiscount(order: OrderFindedType) {
    let value = 0;
    order.products.map((product) => {
      value += product.unitPrice * product.quantity;
      if (product.additionals && product.additionals.length > 0) {
        product.additionals.forEach((additional) => {
          value += additional.price * additional.quantity;
        });
      }
    });
    return value;
  }

  function totalValueDiscount(order: OrderFindedType) {
    let value = 0;
    order.products.forEach((product) => {
      value += product.promotionalPrice * product.quantity;
      if (product.additionals && product.additionals.length > 0) {
        product.additionals.forEach((additional) => {
          value += additional.price * additional.quantity;
        });
      }
    });
    return value;
  }

  const statusList = Object.keys(order.status).map((stat: any) => {
    const status = order.status[stat as keyof typeof order.status];
    return {
      id: Object.getOwnPropertyDescriptor(status, "id")?.value,
      name: Object.getOwnPropertyDescriptor(status, "name")?.value,
      slug: Object.getOwnPropertyDescriptor(status, "slug")?.value,
    };
  });
  const nowStatus = order.allStatus.find(
    (status) => status.id === order.statusId
  );
  const lastStatus = nowStatus
    ? nowStatus.name
    : statusList[statusList.length - 1].name;
  const lastStatusSlug = nowStatus
    ? nowStatus.slug
    : statusList[statusList.length - 1].slug;
  const statusIds = statusList.map((item) => item.id);

  const unlockSynkar = async () => {
    if (order.content && order.content.requestSynkar && order.ext) {
      setLoading(true);
      await api
        .post(
          `/api/pluginconfig/filter`,
          {
            plugintemplateId: 108,
          },
          {
            headers: {
              Authorization: `Bearer ${await getToken()}`,
            },
          }
        )
        .then(async (response) => {
          if (
            response.data.data &&
            response.data.data[0] &&
            response.data.data[0].content &&
            response.data.data[0].content.able === "1"
          ) {
            const synkarData = response.data.data[0].content;
            await api
              .post(
                `/api/orders/unlock-synkar`,
                {
                  requestUuid: order.content.requestSynkar,
                  operationUuid: synkarData.operationCode,
                  clientId: synkarData.clientId,
                  clientSecret: synkarData.clientSecret,
                  orderIdExt: order.ext,
                },
                {
                  headers: {
                    Authorization: `Bearer ${await getToken()}`,
                  },
                }
              )
              .then(async (response) => {
                setLoading(false);
                Swal.fire({
                  icon: "success",
                  title: "Trava desbloqueada!",
                  text: "Abra o robô e retire seu pedido.",
                }).then(() => window.location.reload());
              })
              .catch((e) => {
                setLoading(false);
                Swal.fire({
                  icon: "error",
                  title: "Erro!",
                  text: "Falha ao realizar desbloqueio.",
                });
              });
          } else {
            setLoading(false);
            Swal.fire({
              icon: "error",
              title: "Erro!",
              text: "Não foi possível capturar dados da integração Synkar.",
            });
          }
        })
        .catch((e) => {
          setLoading(false);
          Swal.fire({
            icon: "error",
            title: "Erro!",
            text: "Não foi possível capturar dados da integração Synkar.",
          });
        });
    } else {
      Swal.fire({
        icon: "error",
        title: "Erro!",
        text: "Não foi possível capturar código do pedido Synkar.",
      });
    }
  };

  function chooseModality() {
    switch (order.type) {
      case "withdraw":
        return "Retirada";
      case "delivery":
        return "Entrega";
      case "table":
        return "Mesa";
      case "synkar":
        if (
          order.content &&
          order.content.landmarkSynkarName &&
          order.locationName
        ) {
          return `${order.locationName ? `${order.locationName} - ` : ""}${order.content.landmarkSynkarName
            }`;
        } else return "Entrega";
      case "pluginbot":
        if (
          order.content &&
          order.content.landmarkPluginbotName &&
          order.locationName
        ) {
          return `${order.locationName ? `${order.locationName} - ` : ""}${order.content.landmarkPluginbotName
            }`;
        } else return "Entrega";
      case "internal-delivery":
        const internalDeliveryNumber = localStorage.getItem("internal_number");
        const internalDeliveryName = localStorage.getItem("internal_name");
        if (internalDeliveryNumber && internalDeliveryName)
          return `Entrega - ${order.content.orderAddress?.complement}`;
        else return "Entrega Interna";
      default:
        return "Retirada";
    }
  }

  const showModal = () => {
    setModalOpen(true);
  };

  useEffect(() => {
    if (extended) {
      console.log(order);
    }
  }, [extended]);

  return (
    <div className="order-finded">
      <div className="number-order" onClick={() => setExtended(!extended)}>
        {extended ? (
          <FaMinusCircle color="#636363" />
        ) : (
          <FaPlusCircle color="#636363" />
        )}
        <p>
          Pedido{" "}
          {order.content?.externalCodeERP
            ? order.content.externalCodeERP.split(":")[0]
            : order.ext}
        </p>
      </div>
      {extended && (
        <div className="order-content">
          {order.content && order.content.externalCodeERP && (
            <p>
              <b>Pedido Externo: </b>
              {order.content.externalCodeERP}
            </p>
          )}
          <p>
            <b>Data: </b>
            {order.date}
          </p>
          <p>
            <b>Forma de entrega: </b>
            {chooseModality()}
          </p>
          <div className="status-order">
            {order.type === "counter" ? (
              <b>
                Status:{" "}
                {lastStatusSlug === "order_delivered"
                  ? "Recepcionado"
                  : lastStatusSlug === "ready"
                    ? "Concluído"
                    : "Não encontrado"}
              </b>
            ) : (
              <b>
                {`Status: ${lastStatusSlug === "order_delivered" &&
                    order.type === "withdraw"
                    ? "Retirado"
                    : lastStatusSlug === "packaged" && order.type === "withdraw"
                      ? "Pronto para retirar"
                      : lastStatus
                  }
								`}
              </b>
            )}
            <div className="status-payment">
              {order.type === "counter"
                ? order.allStatus?.map((oneStatus, index) => {
                  if (oneStatus.order === 4) {
                    return (
                      <div
                        className={
                          oneStatus.id === order.statusId
                            ? "status-active success-extreme-left"
                            : "status success-extreme-left"
                        }
                        style={
                          oneStatus.id === order.statusId
                            ? colorActiveStatus
                              ? { backgroundColor: colorActiveStatus }
                              : {}
                            : colorStatus
                              ? { backgroundColor: colorStatus }
                              : {}
                        }
                      >
                        <p style={fontStatus ? { color: fontStatus } : {}}>
                          Recepcionado
                        </p>
                      </div>
                    );
                  } else if (oneStatus.order === 5) {
                    return (
                      <div
                        className={
                          oneStatus.id === order.statusId
                            ? "status-active success-extreme-right"
                            : "status success-extreme-right"
                        }
                        style={
                          oneStatus.id === order.statusId
                            ? colorActiveStatus
                              ? { backgroundColor: colorActiveStatus }
                              : {}
                            : colorStatus
                              ? { backgroundColor: colorStatus }
                              : {}
                        }
                      >
                        <p style={fontStatus ? { color: fontStatus } : {}}>
                          Concluído
                        </p>
                      </div>
                    );
                  }
                })
                : order.allStatus?.map((oneStatus, index) => {
                  if (index === 0) {
                    return (
                      <div
                        className={
                          oneStatus.id === order.statusId
                            ? "status-active success-extreme-left"
                            : "status success-extreme-left"
                        }
                        style={
                          oneStatus.id === order.statusId
                            ? colorActiveStatus
                              ? { backgroundColor: colorActiveStatus }
                              : {}
                            : colorStatus
                              ? { backgroundColor: colorStatus }
                              : {}
                        }
                      >
                        <p style={fontStatus ? { color: fontStatus } : {}}>
                          {oneStatus.name}
                        </p>
                      </div>
                    );
                  } else if (index === order.allStatus.length - 1) {
                    return (
                      <div
                        className={
                          oneStatus.id === order.statusId
                            ? "status-active success-extreme-right"
                            : "status success-extreme-right"
                        }
                        style={
                          oneStatus.id === order.statusId
                            ? colorActiveStatus
                              ? { backgroundColor: colorActiveStatus }
                              : {}
                            : colorStatus
                              ? { backgroundColor: colorStatus }
                              : {}
                        }
                      >
                        <p style={fontStatus ? { color: fontStatus } : {}}>
                          {oneStatus.slug === "order_delivered" &&
                            order.type === "withdraw"
                            ? "Retirado"
                            : oneStatus.slug === "packaged" &&
                              order.type === "withdraw"
                              ? "Pronto para retirar"
                              : oneStatus.name}
                        </p>
                      </div>
                    );
                  } else {
                    return (
                      <div
                        className={
                          oneStatus.id === order.statusId
                            ? "status-active"
                            : "status"
                        }
                        style={
                          oneStatus.id === order.statusId
                            ? colorActiveStatus
                              ? { backgroundColor: colorActiveStatus }
                              : {}
                            : colorStatus
                              ? { backgroundColor: colorStatus }
                              : {}
                        }
                      >
                        <p style={fontStatus ? { color: fontStatus } : {}}>
                          {oneStatus.slug === "order_delivered" &&
                            order.type === "withdraw"
                            ? "Retirado"
                            : oneStatus.slug === "packaged" &&
                              order.type === "withdraw"
                              ? "Pronto para retirar"
                              : oneStatus.name}
                        </p>
                      </div>
                    );
                  }
                })}
            </div>
          </div>
          {lastStatusSlug === "synkar_blocked" && (
            <div className="synkar-button">
              {loading ? (
                <Loading
                  type="spinningBubbles"
                  color="#FFF"
                  width={64}
                  height={64}
                />
              ) : (
                <div className="button-blocked">
                  <MainButton
                    color={
                      config?.webappcolor.fontbutton
                        ? config.webappcolor.fontbutton
                        : "#636363"
                    }
                    backgroundColor={
                      config?.webappcolor.webappbutton
                        ? config.webappcolor.webappbutton
                        : "#EAEAEA"
                    }
                    text="Destravar robô"
                    onClick={async () => await unlockSynkar()}
                  />
                </div>
              )}
            </div>
          )}
          <div className="infos">
            <h2>Loja</h2>
            <p>{order.store}</p>
            {order.type === "withdraw" && <p>{order.address}</p>}
          </div>
          <div className="infos">
            <h2>Suas informações</h2>
            <p>
              <b>Nome:</b> {order.user.name}
            </p>
            <p>
              {order.user.cpf ? (
                <>
                  <b>CPF:</b> {order.user.cpf}
                </>
              ) : (
                <>
                  <b>CNPJ:</b> {order.content.cnpj}
                </>
              )}
            </p>
            <p>
              {order.type.includes("delivery") ? (
                <b>Endereço de entrega: </b>
              ) : (
                <b>Endereço de retirada: </b>
              )}
              {order.address}
            </p>
            {order.type === "withdraw" &&
              order.content &&
              order.content.orderAddress &&
              order.content.orderAddress.otherPersonToWithdrawal && (
                <p>
                  <b>Responsável pela retirada: </b>
                  {`${order.content.orderAddress.otherPersonToWithdrawal.name
                      ? order.content.orderAddress.otherPersonToWithdrawal.name
                      : ""
                    } 
									${order.content.orderAddress.otherPersonToWithdrawal.cpf
                      ? order.content.orderAddress.otherPersonToWithdrawal.cpf
                      : ""
                    }`}
                </p>
              )}
          </div>
          {order.observation && (
            <div className="infos">
              <h2>Observações</h2>
              <p>{order.observation}</p>
            </div>
          )}

          {order?.cartCustomer?.seller && (
            <div className="infos">
              <h2>Informações do Vendedor</h2>
              <p>
                <b>Nome:</b> {order?.cartCustomer?.seller?.name}
              </p>
            </div>
          )}

          <div className="products-search">
            <div className="header-search">
              <h2>Produtos</h2>
              <p>Qtd.</p>
              <p>De</p>
              <p>Por</p>
              <p>Total</p>
            </div>
            {order.products.map((product) => {
              let priceAdditionals = 0;
              if (product.additionals) {
                let tempPrice = 0;
                product.additionals.map(
                  (additional) =>
                    (tempPrice += additional.quantity * additional.price)
                );
                priceAdditionals = tempPrice;
              }
              return (
                <div className="body" key={product.id}>
                  <div>
                    <p className="product-name">{product.name}</p>
                    {omitGrade &&
                      Object.entries(product.variation).map(([key, value]) => {
                        if (key !== "VARIATION" && value !== "NONE") {
                          return (
                            <p className="product-variation" key={key}>
                              {key === "NOME_COR" ? "COR" : key}: {value}
                            </p>
                          );
                        }
                        return null;
                      })}
                    {showSku && product?.sku && (
                      <p className="product-variation">SKU: {product.sku}</p>
                    )}
                    {product.fractions && product.fractions.length > 0 && (
                      <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                        {organizeFractions(product.fractions).map((fract) => (
                          <p className="product-variation" key={`fractional-${fract.id}`}>
                            {fract.quantity}/{product.fractions.length} {fract.name}
                          </p>
                        ))}
                      </div>
                    )}
                    {product.additionals && product.additionals.length > 0 && (
                      <div style={{ maxHeight: "4rem", overflowY: "auto" }}>
                        {product.additionals.map((additional) => (
                          <p className="product-variation">
                            {additional.quantity}x {additional.name} (
                            {floatToPrice(additional.price)})
                          </p>
                        ))}
                      </div>
                    )}
                    {product.observation && (
                      <p className="product-variation">{product.observation}</p>
                    )}
                  </div>
                  <p>{product.quantity}</p>
                  <p>
                    {floatToPrice(
                      product.unitPrice * product.quantity +
                      priceAdditionals * product.quantity
                    )}
                  </p>
                  <p>
                    {floatToPrice(
                      product.promotionalPrice * product.quantity +
                      priceAdditionals * product.quantity
                    )}
                  </p>
                  <p>
                    {floatToPrice(
                      product.unitPrice * product.quantity +
                      priceAdditionals * product.quantity
                    )}
                  </p>
                </div>
              );
            })}
          </div>
          <div className="value-infos">
            <div className="value">
              <p>Valor dos produtos</p>
              <p>{floatToPrice(totalValueWithoutDiscount(order))}</p>
            </div>
            <div className="value">
              <p>Você economiza</p>
              <p>
                {floatToPrice(
                  totalValueWithoutDiscount(order) - totalValueDiscount(order)
                )}
              </p>
            </div>
            <div className="value">
              <p>Valor com desconto</p>
              <p>{floatToPrice(totalValueDiscount(order))}</p>
            </div>
            <div className="value">
              <p>
                Taxa de {order.type === "withdraw" ? "retirada" : "entrega"}
              </p>
              <p>{floatToPrice(order.freight)}</p>
            </div>
            <div className="value-total">
              <p>Total a pagar</p>
              <p>{floatToPrice(totalValueDiscount(order) + order.freight)}</p>
            </div>
            {order.status[order.status.length - 1].order < 4 && (
              <div
                className="row-text cancel-button"
                style={{ marginTop: "0.2rem", paddingTop: "0px !important" }}
              >
                <button onClick={() => showModal()}>
                  Deseja <span>cancelar o seu pedido?</span>
                </button>
              </div>
            )}
          </div>
        </div>
      )}
      <ModalCancel
        isOpen={modalOpen}
        setIsOpen={setModalOpen}
        orderIdExt={
          order.content?.externalCodeERP
            ? order.content.externalCodeERP.split(":")[0]
            : order.ext
        }
      />
    </div>
  );
}
